import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { HOMEPAGE } from '../../navigation/Constants';
import { RootState } from '../../redux/store';
import { getMemberAdvancedSearch, resetAdvancedSettings, updateAdvancedSettings } from '../../services/memberService';
import { AdvancedSearchProps, AdvancedSearchSentData } from '../../typings/advancedSearch'
import Switch from "react-switch";
import AdvancedSearchTag from './components/AdvancedSearchTag';
import Loader from 'react-loader-spinner';
import NiceModal from "@ebay/nice-modal-react";
import AdvancedSearchQuestion from "./components/AdvancedSearchQuestion";
import AgeFilterSelected from "./components/AgeFilterSelected";
import { setNeedToRefresh } from '../../redux/carpet';
import LocationFilter from './components/LocationFilter';
import { LocationFilterType } from '../../helpers/Enums';

const AdvancedSearch = () => {
   const dispatch = useDispatch();
   const history = useHistory();
   const [isLoading, setIsLoading] = useState<boolean>(false);
   const [memberAdvancedSearch, setMemberAdvancedSearch] = useState<AdvancedSearchProps>();
   const { memberCode: myMemberCode } = useSelector((state: RootState) => state.member);
   const [selectedLookingFor, setSelectedLookingFor] = useState<number[]>([]);
   const [minAge, setMinAge] = useState<number>(-1);
   const [maxAge, setMaxAge] = useState<number>(-1);
   const [showOnlyVerifiedProfile, setShowOnlyVerifiedProfile] = useState<boolean>(false);
   const [selectedQuestion, setSelectedQuestion] = useState<any>([]);
   const [locationFilter, setLocationFilter] = useState<LocationFilterType>(1);

   useEffect(() => {
      fetchData();
      return () => setIsLoading(false);
   }, [])


   const fetchData = async () => {
      setIsLoading(true);
      const { data } = await getMemberAdvancedSearch(myMemberCode);
      setUserData(data);
   };

   const resetMemberAdvancedSearch = async () => {
      const { data } = await resetAdvancedSettings(myMemberCode);
      setUserData(data);
   };

   const setUserData = (data: AdvancedSearchProps) => {
      setMemberAdvancedSearch(data);
      setMaxAge(data.maxAgeValue);
      setMinAge(data.minAgeValue);
      setLocationFilter(data.locationFilter)
      handleSetSelectedQuestion(data);
      setShowOnlyVerifiedProfile(data.showOnlyVerifiedProfiles);
      setSelectedLookingFor(data.lookingFor.filter((lookingFor) => lookingFor.isSelected).map((lookingFor) => { return lookingFor.value }));
      setIsLoading(false);
   };

   const handleSetSelectedQuestion = (data: AdvancedSearchProps) => {
      const selectedQuestions = [];
      const questions = data.questions;
      for (const question of questions) {
         const selectedTags = question.tags?.filter((x) => x.isSelected);
         if (selectedTags && selectedTags.length > 0) {
            selectedQuestions.push({
               questionId: question.questionId,
               questionTag: selectedTags.map((x) => x.value),
               questionAnswers: selectedTags.map((x) => x.text)
            })
         }
      }
      setSelectedQuestion(selectedQuestions);
   };

   const addLookingFor = (tag: number) => {
      if (selectedLookingFor.length < 4)
         setSelectedLookingFor([...selectedLookingFor, tag]);
   };

   const removeLookingFor = (toRemove: number) => setSelectedLookingFor([...selectedLookingFor.filter((tagId: number) => tagId !== toRemove)]);


   const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      await updateAdvancedSettings(myMemberCode, createAdvancedSearchObject());
      dispatch(setNeedToRefresh(true));
      history.goBack();
   };

   const handleCloseAdvancedSearchModal = () => {
      history.goBack();
      NiceModal.hide("advancedSearch_modal");
   };


   const setQuestionAnswer = (questionId: number, questionTag: number[]) => {

      const questions = [...selectedQuestion];
      let question = selectedQuestion.filter((x: any) => x.questionId === questionId)[0];
      let getQuestionAnswerTags = memberAdvancedSearch?.questions.filter((x: any) => x.questionId === questionId)[0].tags;
      let questionAnswers = getQuestionAnswerTags?.filter(x => questionTag.includes(x.value)).map(x => x.text);

      if (question) {
         question.questionTag = questionTag
         question.questionAnswers = questionAnswers;
      }
      else {
         let questionToAdd = {
            questionId,
            questionTag,
            questionAnswers
         }
         questions.push(questionToAdd);
      }
      setSelectedQuestion(questions);
   };

   const createAdvancedSearchObject = () => {
      return {
         maxAge,
         minAge,
         selectedLookingFor,
         selectedQuestion,
         showOnlyVerifiedProfile,
         locationFilter
      }
   };

   return (
      <>

         {isLoading ?
            <div style={{ height: "80vh", margin: "auto", display: 'flex', justifyContent: "center", alignItems: "center" }}>
               <Loader type="ThreeDots" color="#f47373" height={60} width={60} />
            </div>
            :
            <>
               <div className="content_sec full wf-section">
                  <div className="search_top">
                     <a href="#" onClick={handleCloseAdvancedSearchModal} className="top_back search w-inline-block">
                        <img src="/assets/images/ic_back_white.svg" loading="lazy" alt="" />
                     </a>
                     <h2 className="search_top_title">ההעדפות שלי</h2>

                  </div>
                  <div className="search_sec w-form">
                     <div className="form_field_content important">
                        <label htmlFor="name" className="field_title important">
                           מה חשוב לך
                           <br />
                           בהיכרות עם הצד השני?
                        </label>
                        <div >נשמור את ההעדפות שלך כדי להציג לך את האנשים שבאמת היית רוצה להכיר</div>
                     </div>


                     <form onSubmit={handleSubmit}>
                        <div className="form_field_content">
                           <label htmlFor="name" className="field_title">
                              איזה סוג היכרות מתאים לך?
                              <br />
                              אפשר כמובן לבחור יותר מאפשרות אחת
                           </label>

                           <div className="form_links_group">
                              {memberAdvancedSearch?.lookingFor.map((lookingFor, index) => {
                                 const { text, value } = lookingFor;
                                 const isSelected = selectedLookingFor.includes(value);
                                 const onPress = () => isSelected ? removeLookingFor(value) : addLookingFor(value)
                                 return (
                                    <AdvancedSearchTag key={index} {...{ text, index, onPress, isSelected }} />
                                 )

                              })}

                           </div>
                        </div>

                        <div className="form_field_content">
                           <label htmlFor="name" className="field_title">
                              מאיזה אזור להציג לך אנשים?
                           </label>

                           <div className="form_links_group">
                              <LocationFilter
                                 locationFilter={locationFilter}
                                 setLocationFilter={setLocationFilter}
                              />
                           </div>
                        </div>

                        <div className="form_field_content duo">
                           <AgeFilterSelected
                              ages={memberAdvancedSearch?.ageRange ?? []}
                              minAge={minAge}
                              setMinAge={setMinAge}
                              setMaxAge={setMaxAge}
                              maxAge={maxAge} />
                        </div>
                        {/* <div className="form_field_content">
                                    <div className="form_links_group">
                                        <a href="#" className="check_link trio w-inline-block">
                                            <div>טקסט דינמי</div>
                                        </a>
                                        <a href="#" className="check_link trio w-inline-block">
                                            <div>טקסט דינמי</div>
                                        </a>
                                        <a href="#" className="check_link trio check w-inline-block">
                                            <div>טקסט דינמי</div>
                                        </a>
                                    </div>
                                </div> */}
                        <div className="form_field_content prior">
                           <label htmlFor="name" className="field_title">
                              מה חשוב לך בפרטנר שלך?
                           </label>
                           <div className="search_field_txt">
                              הגדר כאן מה אתה מחפש אצל הצד השני לצורך דיוק תוצאות החיפוש
                           </div>
                           <div className="subscribe_group">
                              <img
                                 src="assets/images/ic_premium_menu.svg"
                                 loading="lazy"
                                 alt=""
                                 className="prem_icon_txt"
                              />
                              <div className="icon_red_txt">למנויי פרימיום</div>
                           </div>

                           <AdvancedSearchQuestion
                              selectedQuestionTags={selectedQuestion}
                              setQuestionAnswers={setQuestionAnswer}
                              questions={memberAdvancedSearch?.questions ?? []} />
                        </div>
                        {/* <div className="form_field_content">
                           <div className="search_verify_group">
                              <Switch
                                 onChange={(e) => setShowOnlyVerifiedProfile(e)}
                                 checked={showOnlyVerifiedProfile}
                              />
                              <label htmlFor="name" className="field_title verify">
                                 הציגו לי רק פרופילים מאומתים
                              </label>
                              <img
                                 src="/assets/images/ic_premium.svg"
                                 loading="lazy"
                                 alt=""
                                 className="search_premium_ic"
                              />
                           </div>
                        </div> */}
                        <div className="form_send_group">
                           <div className="form_buttons_group filtering">
                              <input autoComplete="off"
                                 type="submit"
                                 value="בחרתי, בואו נמשיך "
                                 data-wait
                                 className="button filtering w-button"
                              />
                              <a href="#" onClick={resetMemberAdvancedSearch} className="clear_link">איפוס</a>
                           </div>
                        </div>
                     </form>
                  </div>
               </div>
            </>


         }


      </>
   )
}


export default AdvancedSearch;